import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'data-protection-policy',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less'],
})
export class DataProtectionPolicyComponent implements OnInit {
  title: string = ''
  selectedIndex: number = 1;
  constructor(
    private route: ActivatedRoute,private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params=>{
      this.selectedIndex = params['index'] || 1;
    })
    this.translate.get('Data_PROTECTION_POLICY').subscribe(translated => {
      this.title = translated;
    });
  }

  handleChangeTabset(data: any){
    const nzTitle = data.tab.nzTitle;
    this.selectedIndex = data.index;
    this.title = nzTitle || '';
  }
}
